import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaGithub, FaLinkedin } from 'react-icons/fa';

const Overlay = styled.div`
  display: ${props => props.$menuOpen ? 'block' : 'none'};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  
  @media (min-width: 769px) {
    display: none;
  }
`;

const NavbarContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 0.85rem 2rem;
  transition: all 0.3s ease;
  background-color: ${props => props.$scrolled || props.$menuOpen ? 'rgba(255, 255, 255, 0.95)' : 'rgba(248, 250, 252, 0.88)'};
  backdrop-filter: blur(10px);
  border-bottom: 1px solid ${props => props.$scrolled || props.$menuOpen ? 'var(--border-color)' : 'transparent'};
  box-shadow: ${props => props.$scrolled || props.$menuOpen ? 'var(--shadow-sm)' : 'none'};
`;

const NavContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.a`
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--primary-color);
  text-decoration: none;
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    display: ${props => props.$menuOpen ? 'flex' : 'none'};
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    width: 100%;
    background-color: var(--white);
    padding: 1.5rem 0;
    box-shadow: var(--shadow-md);
    align-items: center;
    z-index: 1000;
  }
`;

const NavLink = styled.a`
  margin-left: 1.5rem;
  color: var(--primary-color);
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    color: var(--secondary-color);
  }
  
  @media (max-width: 768px) {
    margin: 0.75rem 0;
    font-size: 1.1rem;
    padding: 0.5rem 1rem;
    
    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
      border-radius: 4px;
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  align-items: center;
  margin-left: 2rem;
  
  @media (max-width: 768px) {
    margin: 1rem 0 0 0;
  }
`;

const SocialLink = styled.a`
  margin-left: 0.9rem;
  color: var(--primary-color);
  font-size: 1.05rem;
  transition: all 0.3s ease;
  
  &:hover {
    color: var(--secondary-color);
    transform: translateY(-2px);
  }
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.5rem;
  color: var(--primary-color);
  padding: 0.5rem;
  transition: all 0.3s ease;
  
  &:hover {
    color: var(--secondary-color);
    transform: scale(1.1);
  }
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const Navbar = ({ scrollY }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (scrollY > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  }, [scrollY]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  
  const closeMenu = () => {
    if (window.innerWidth <= 768) {
      setMenuOpen(false);
    }
  };

  return (
    <>
      <Overlay $menuOpen={menuOpen} onClick={closeMenu} />
      <NavbarContainer $scrolled={scrolled} $menuOpen={menuOpen}>
        <NavContent>
          <Logo href="#home" onClick={closeMenu}>Sultan Malik</Logo>
          
          <MenuButton onClick={toggleMenu}>
            {menuOpen ? '✕' : '☰'}
          </MenuButton>
          
          <NavLinks $menuOpen={menuOpen}>
            <NavLink href="#home" onClick={closeMenu}>Home</NavLink>
            <NavLink href="#about" onClick={closeMenu}>About</NavLink>
            <NavLink href="#skills" onClick={closeMenu}>Skills</NavLink>
            <NavLink href="#projects" onClick={closeMenu}>Projects</NavLink>
            <NavLink href="#experience" onClick={closeMenu}>Experience</NavLink>
            <NavLink href="#education" onClick={closeMenu}>Education</NavLink>
            <NavLink href="#contact" onClick={closeMenu}>Contact</NavLink>
            
            <SocialLinks>
              <SocialLink href="https://github.com/sultanmalik04" target="_blank" rel="noopener noreferrer">
                <FaGithub />
              </SocialLink>
              <SocialLink href="https://www.linkedin.com/in/malik-sultan-ahmed/" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </SocialLink>
            </SocialLinks>
          </NavLinks>
        </NavContent>
      </NavbarContainer>
    </>
  );
};

export default Navbar;
